import Router from "@/common/router/Router";

export default class FacilityRouter extends Router {
  static BASE_PATH = "/facility";
  static SHOW_ROUTE_NAME = "facility-show";
  static CREATE_ROUTE_NAME = "facility-create";
  static UPDATE_ROUTE_NAME = "facility-update";
  static LIST_ROUTE_NAME = "facility-list";

  constructor() {
    super(
      FacilityRouter.BASE_PATH,
      FacilityRouter.SHOW_ROUTE_NAME,
      FacilityRouter.CREATE_ROUTE_NAME,
      FacilityRouter.UPDATE_ROUTE_NAME,
      FacilityRouter.LIST_ROUTE_NAME
    );
  }
}

export const facilityRouter = new FacilityRouter();
